import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Grid } from "@mui/material";

import CustomDataGrid from "./components/CustomDataGrid";
import useOttPlan from "../../../hooks/useOttPlan";
import { useDialog } from "../../../contexts/DialogContext";
import { getTimeStamp } from "../../../utils/common";

function DataGridPage(props) {
  const { getAllOttPlans, ottPlans, paging, isLoading, downloadFile } = useOttPlan();

  const { totalNumberOfRecords, hasNextPage, pageNumber, pageSize } = paging;
  const { t } = useTranslation();
  const { openDialog } = useDialog();

  const currentPayload = {
    filters: [],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "ottPlanName",
        sort: "ASC",
      },
    ],
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);

  const [payload, setPayload] = useState(currentPayload);

  const [filterResetFunc, setFilterResetFunc] = useState(
    () => () => console.log("Refresh initialized"),
  );

  const fetchData = async () => {
    await getAllOttPlans(payload);
  };

  const refreshPage = () => {
    setPayload(currentPayload);
    filterResetFunc();
    setPaginationModel({
      page: 0,
      pageSize: 100,
    });
  };

  const onPageChange = (newPaginationModel) => {
    console.log(newPaginationModel, "pagepage");

    const pagination = {
      pageNumber: newPaginationModel.page === 0 ? 1 : newPaginationModel.page + 1,
      pageSize: newPaginationModel.pageSize, // Update pageSize dynamically
    };

    setPayload((prev) => ({ ...prev, pagination }));
    setPaginationModel(newPaginationModel);
  };

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 100,
  });

  const paginationMetaRef = useRef();

  // Memoize to avoid flickering when the `hasNextPage` is `undefined` during refetch
  const paginationMeta = React.useMemo(() => {
    if (hasNextPage !== undefined && paginationMetaRef.current?.hasNextPage !== hasNextPage) {
      paginationMetaRef.current = { hasNextPage };
    }
    return paginationMetaRef.current;
  }, [hasNextPage]);

  const isInitialMount = useRef(true);
  useEffect(() => {
    fetchData();
  }, [payload]);

  const exportFile = async (fileType) => {
    await downloadFile(fileType, payload);
  };

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <CustomDataGrid
            trans={t}
            addPage={null}
            editPage={null}
            refreshPage={refreshPage}
            downloadFile={exportFile}
            setFilterResetFunc={setFilterResetFunc}
            openDownloadDialog={null}
            id="ottPlanId"
            isLoading={isLoading}
            sortModel={sortModel}
            handleSortModelChange={handleSortModelChange}
            payload={payload}
            setPayload={setPayload}
            rows={ottPlans}
            rowCount={totalNumberOfRecords}
            onPaginationModelChange={onPageChange}
            paginationMeta={paginationMeta}
            paging={{
              pageNumber: pageNumber,
              pageSize: pageSize,
            }}
            paginationModel={paginationModel}
            permissionKeys={[]}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default DataGridPage;
